import {components} from "react-select";
import React from "react";

const SelectFieldInput = (props) => {
    return <components.Input {...props} required={props.selectProps.required && !props.hasValue}>
        {props.children}
    </components.Input>;
};

export default SelectFieldInput;